function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { number, oneOfType, string, bool } from 'prop-types';
import styled, { keyframes, css } from 'styled-components';
export { default as AmpImg } from './index.amp';
var fadeInKeyframes =
/*#__PURE__*/
keyframes(["from{opacity:0;}to{opacity:1;}"]);
var fadeIn =
/*#__PURE__*/
css(["animation:", " 0.2s linear;transition:visibility 0.2s linear;"], fadeInKeyframes);
var StyledImg =
/*#__PURE__*/
styled.img.withConfig({
  displayName: "StyledImg",
  componentId: "sc-7vx2mr-0"
})(["display:block;width:100%;visibility:visible;", ";"], function (props) {
  return props.fade && fadeIn;
});
export var Img = function Img(props) {
  var srcset = props.srcset,
      otherProps = _objectWithoutProperties(props, ["srcset"]);

  return React.createElement(StyledImg, _extends({
    srcSet: srcset
  }, otherProps));
};
Img.propTypes = {
  alt: string.isRequired,
  fade: bool,
  height: oneOfType([string, number]),
  sizes: string,
  src: string.isRequired,
  srcset: string,
  width: oneOfType([string, number])
};
Img.defaultProps = {
  fade: false,
  height: null,
  sizes: null,
  srcset: null,
  width: null
};
export default Img;